module.exports = __webpack_public_path__ + "static/img/7.577ec5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/7.png
// module id = DZ1j
// module chunks = 0